import React, { useEffect, useState } from "react";
import CreateTask from "components/TodoList/CreateTask/CreateTask";
import { useTeamContext } from "store/contexts/teamContext";
import TeamService from "services/TeamService";
import InfiniteScroll from "react-infinite-scroll-component";
import { TimelineContext } from "store/contexts/timelineContext";
import Loader from "components/Loader";
import { useParams } from "react-router-dom";
import Button from "components/CustomButton";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import FilterListTask from "components/TodoList/FilterListTask/FilterListTask";
import TodoListModal from "components/TodoList/TimelineTodoTasks/TodoListModal";
import TimelineTodoListTasks from "components/TodoList/TimelineTodoTasks/TimelineTodoListTasks";

export default ({ listTeamId, listTodoId }) => {
  const { team } = useTeamContext();
  const [timelineListTask, setTimelineListTask] = useState([]);
  const [selectlistTask, setListTask] = useState(null);
  const [hide, setHide] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const { listId } = useParams();
  const { teamId } = useTeamActionContext();
  const [myTeamId] = useState(teamId ?? listTeamId);
  const [myListId] = useState(listId ?? listTodoId);
  const [meta, setMeta] = useState();
  const [order_by, setOrderBy] = useState("oldest");
  const [status_id, setStatusId] = useState(null);
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    try {
      (async () => {
        var response = await TeamService.getTodoListAllTask(
          myTeamId,
          myListId,
          page,
          order_by,
          status_id
        );

        setTimelineListTask(
          Array.from(new Set([...timelineListTask, ...response.data.data]))
        );
        setMeta(response?.data?.meta);
        setTotal(response?.data?.meta?.total);
        setIsLoading(false);
      })();
    } catch (e) {
      console.log(e);
    }

    // eslint-disable-next-line
  }, [team.id, page, order_by, status_id]);

  const createTask = (task) => {
    // setCreateTodoOpen(false);
    if (!task) {
      return;
    }

    if (meta?.last_page > page && order_by === "oldest") {
      return;
    }

    setTimelineListTask(
      Array.from(
        new Set(
          order_by === "newest"
            ? [task, ...timelineListTask]
            : [...timelineListTask, task]
        )
      )
    );

    incrementTotal();
  };

  const updateTask = (task) => {
    const timelineCopy = [...timelineListTask];

    timelineCopy[
      timelineCopy.findIndex((tTask) => {
        return tTask.id === task.id;
      })
    ] = {
      ...task,
    };

    setTimelineListTask(timelineCopy);
  };

  const selectTodoListItem = (listTask) => {
    setListTask(listTask);
  };

  const closeModal = () => {
    if (hide) setHide(false);
    setListTask(false);
  };

  const incrementTotal = () => {
    setTotal(total + 1);
  };

  const getNextPageData = () => {
    setIsLoading(true);
    setPage(page + 1);
  };

  const deleteTask = (task) => {
    setTimelineListTask(
      timelineListTask.filter((timeline) => timeline.id !== task.id)
    );
    setTotal(total - 1);
    closeModal();
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <h4>
          <Button color="warning" onClick={getNextPageData}>
            Load More
          </Button>
        </h4>
      )}
    </>
  );

  return (
    <TimelineContext.Provider
      value={{
        createTask,
        updateTask,
        deleteTask,
        selectTodoListItem,
        setHide,
        selectlistTask,
      }}
    >
      <div className="tasks-btn mb-3">
        <CreateTask teamId={myTeamId} listId={myListId} />
        <FilterListTask
          setStatusId={setStatusId}
          setPage={setPage}
          setIsLoading={setIsLoading}
          setTimelineListTask={setTimelineListTask}
          setOrderBy={setOrderBy}
          order_by={order_by}
        />
      </div>
      <InfiniteScroll
        style={{ overflow: "hidden" }}
        dataLength={total ?? 0}
        next={getNextPageData}
        hasMore={timelineListTask.length !== total}
        loader={LoadingContainer}
        scrollableTarget="main-panel-right"
        endMessage={
          <div style={{ textAlign: "center" }}>
            {total > 0 && (
              <div style={{ textAlign: "center" }}>
                Yay! You have seen it all
              </div>
            )}
          </div>
        }
      >
        <TimelineTodoListTasks
          listTasks={timelineListTask}
          total={total}
          setPage={setPage}
        />
      </InfiniteScroll>
      <TodoListModal
        listTask={selectlistTask}
        open={selectlistTask}
        hide={hide}
        close={closeModal}
      />
    </TimelineContext.Provider>
  );
};
